import {WlRangeSlider} from "./rangeSlider";

export * from './rangeSlider.component';
export default WlRangeSlider;

customElements.define("wl-range-slider", WlRangeSlider);
